module.exports = __webpack_public_path__ + "static/img/samajuri (19).404e294.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/samajuri/samajuri (19).jpg
// module id = mHtl
// module chunks = 0